import { render, staticRenderFns } from "./TaskListHeader.vue?vue&type=template&id=90c0c6d6&scoped=true&"
import script from "./TaskListHeader.vue?vue&type=script&lang=ts&"
export * from "./TaskListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TaskListHeader.vue?vue&type=style&index=0&id=90c0c6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c0c6d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow,VSpacer})
